module.exports = __webpack_public_path__ + "img/en_zh.1eac77b8.svg";